import React, { createContext, useContext, useEffect, useState } from 'react'

const ThemeContext = createContext()

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState('system')

    useEffect(() => {
        // 1. Initial load preference
        const storedTheme = localStorage.getItem('theme')
        if (storedTheme) {
            setTheme(storedTheme)
        } else {
            setTheme('system')
        }
    }, [])

    useEffect(() => {
        // 2. Apply theme logic
        const root = window.document.documentElement

        // Remove previous classes
        root.classList.remove('light', 'dark')

        if (theme === 'system') {
            const systemTheme = window.matchMedia('(prefers-color-scheme: dark)')
                .matches
                ? 'dark'
                : 'light'
            root.classList.add(systemTheme)
        } else {
            root.classList.add(theme)
        }

        // 3. Persist preference (unless it's system on initial load)
        if (theme !== 'system') {
             localStorage.setItem('theme', theme)
        } else {
             localStorage.removeItem('theme')
        }
    }, [theme])

    // Listen for system changes if mode is 'system'
    useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
        
        const handleChange = () => {
            if (theme === 'system') {
                const root = window.document.documentElement
                root.classList.remove('light', 'dark')
                root.classList.add(mediaQuery.matches ? 'dark' : 'light')
            }
        }

        mediaQuery.addEventListener('change', handleChange)
        return () => mediaQuery.removeEventListener('change', handleChange)
    }, [theme])

    const value = {
        theme,
        setTheme,
        isDark: 
            theme === 'dark' || 
            (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches)
    }

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    )
}

export const useTheme = () => {
    const context = useContext(ThemeContext)
    if (context === undefined) {
        throw new Error('useTheme must be used within a ThemeProvider')
    }
    return context
}
